// TODO(PASDILER-1952): заменить на контракты backend, когда появится API
// массовой загрузки/проверки сотрудников.

export interface IBaseStaffUploadTypeOption {
  value: string;
  label: string;
}

export const BASE_STAFF_UPLOAD_TYPE_OPTIONS: IBaseStaffUploadTypeOption[] = [
  { value: "employeeData", label: "Загрузка данных сотрудника" },
];

export interface IBaseStaffUploadCheckRow {
  id: string;
  fio: string;
  checkResult: string;
  field: string;
  conclusion: string;
}

export const BASE_STAFF_UPLOAD_CHECK_MOCK: IBaseStaffUploadCheckRow[] = [
  {
    id: "1",
    fio: "Иванов Иван Иванович",
    checkResult: "Данные некорректны",
    field: "Электронная почта",
    conclusion: "Загрузите корректные данные",
  },
  {
    id: "2",
    fio: "Баранов Иван Борисович",
    checkResult: "Поле незаполнено",
    field: "Должность",
    conclusion: "Обязательное поле. Требуется заполнить",
  },
  {
    id: "3",
    fio: "Алексеева Анна Николаевна",
    checkResult: "Поле незаполнено",
    field: "Номер телефона",
    conclusion: "Обязательное поле. Требуется заполнить",
  },
  {
    id: "4",
    fio: "Коптиевский Даниил Игоревич",
    checkResult: "Данные некорректны",
    field: "Электронная почта",
    conclusion: "Загрузите корректные данные",
  },
  {
    id: "5",
    fio: "Мичурина Евгения Станиславовна",
    checkResult: "Поле незаполнено",
    field: "Должность",
    conclusion: "Обязательное поле. Требуется заполнить",
  },
  {
    id: "6",
    fio: "Якутенко Наталья Анатольевна",
    checkResult: "Данные некорректны",
    field: "Номер телефона",
    conclusion: "Загрузите корректные данные",
  },
  {
    id: "7",
    fio: "Смирнов Александр Вячеславович",
    checkResult: "Поле незаполнено",
    field: "Электронная почта",
    conclusion: "Обязательное поле. Требуется заполнить",
  },
];

export const getBaseStaffUploadCheckPage = (
  page: number,
  count: number,
): { rows: IBaseStaffUploadCheckRow[]; total: number } => {
  const start = page * count;

  return {
    rows: BASE_STAFF_UPLOAD_CHECK_MOCK.slice(start, start + count),
    total: BASE_STAFF_UPLOAD_CHECK_MOCK.length,
  };
};
